const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';

const _ = {
    find:       require('lodash/find'),
    filter:     require('lodash/filter'),
    map:        require('lodash/map'),
    get:        require('lodash/get'),
};

const Strings = require('../../../../app/shared/Strings');
// const Globals = require('../../../../app/globals');
const ShortCourseConstants = require('../../../../app/shared/ShortCourseConstants');

const ShortCourseActions =          require('../../actions/ShortCourseActions');
const ShortCourseEditorActions =    require('../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore =      require('../../stores/ShortCourseEditorStore');

const ForgeError = require('../../util/error');
const AssetUtil = require('../../util/asset');

import ErrorBox from '../common/ErrorBox';
import ControlledInput from '../common/ControlledInput';
import LoadingSpinner from '../loading/LoadingSpinner';
import AccessibleIcon from '../common/AccessibleIcon';
import SingleAssetInput from '../common/SingleAssetInput';
import ConfirmModal from '../modal/ConfirmModal';

const propTypes = {
    doc: PropTypes.object.isRequired,
    courseHash: PropTypes.string.isRequired,
};

const defaultProps = {
};

class EditCoachStickersModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imageUpdateActionID: null,
            error: null,
        };
    }

    addSticker=()=>{
        ShortCourseEditorActions.addSticker(uuid.v4());
    }
    
    updateImage=(coach_sticker_id, assetParams, files)=>{
        const imageUpdateActionID = uuid.v4();
        let params = {...assetParams, 
            courseHash: this.props.courseHash,
            asset_name: `coach sticker ${coach_sticker_id}`
        };
        this.setState({ imageUpdateActionID },()=>{
            // after updating state, upload the image
            ShortCourseActions.addShortCourseVersionAsset(imageUpdateActionID, params, files, (asset_url)=>{
                this.setState({error:null,imageUpdateActionID:null},()=>{
                    ShortCourseEditorActions.setStickerSrc(uuid.v4(),coach_sticker_id,asset_url);
                });
            });
        });
    }
    
    setStickerDisplayName=(entry, e)=>{
        if (!entry.specialPurpose) {
            ShortCourseEditorActions.setStickerDisplayName(uuid.v4(),entry.id, e.target.value);
        }
    }
    
    deleteSticker=(entry)=>{
        this.setState({
            modalConfirm: {
                modalTitle: "Confirm Delete",
                text: `delete sticker ${entry.id}: ${entry.displayName}`,
                confirmHandler: ()=>{
                    this.setState({modalConfirm: null},()=>{
                        if (entry.specialPurpose) {
                            ShortCourseEditorActions.setStickerSrc(uuid.v4(),entry.id,''); // blank the src but don't delete the entry
                        }
                        else {
                            ShortCourseEditorActions.deleteSticker(uuid.v4(),entry.id);
                        }
                    });
                },
                cancelHandler: ()=>{
                    this.setState({modalConfirm: null})
                },
            }
        });
    }

    updateImageOnError=(errorMsg)=>{
        this.setState({error:errorMsg, imageUpdateActionID:null});
        // window.alert(errorMsg || 'Error');
    }

    render() {
        // let stickers = COACH_TEXT_STICKERS.concat(ShortCourseConstants.SPECIAL_STICKERS);

        if (this.state.modalConfirm) {
            let { modalTitle, text, confirmHandler, cancelHandler } = this.state.modalConfirm;
            return (
                <div key="confirmModal" className="full-screen-modal text-centered">
                    <ConfirmModal 
                        theme="new"
                        show={true}
                        modalTitle={modalTitle}
                        text={text}
                        buttonText={"confirm"}
                        confirmHandler={confirmHandler}
                        cancelButtonText={"cancel"}
                        cancelHandler={cancelHandler}
                        closeHandler={cancelHandler}
                        confirmButtonBsStyle="info"
                        cancelButtonBsStyle="info"
                        enforceFocus
                        restoreFocus
                        backdrop
                    />
                </div>
            );
        }

        return (
            <Modal key="mainModal"
                className="short-course-coach-stickers-modal"
                show={true}
                keyboard
                autoFocus
                enforceFocus={false}
                restoreFocus={false}
                backdrop={false}
                animation={false}
                //container={mountNode}
                onHide={this.props.closeHandler}
                aria-labelledby="coach-stickers-editor"
            >
                <Modal.Header
                    closeButton
                    closeLabel={Strings['en'].common.CLOSE}
                    onHide={this.props.closeHandler}
                >
                    <Modal.Title id="coach-stickers-editor">{'Coach Stickers'}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="formlike coach-stickers-editor-body">
                    {_.map(this.props.doc.client_content.coach_stickers,(entry,index)=>{
                        let stickerSrc = entry.src;
                        if (stickerSrc) {
                            stickerSrc = stickerSrc.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
                        }
                        return (
                        <div className="sticker-tile" key={index}>
                            {stickerSrc ? <img src={stickerSrc}/> : null }
                            <SingleAssetInput
                                buttonOnly
                                browseText={stickerSrc ? "Replace" : "Upload"}
                                assetType="image"
                                assetRole="normal"
                                accept="image/*"
                                onChange={this.updateImage.bind(this,entry.id)}
                                onError={this.updateImageOnError}
                                validateAssetType={AssetUtil.validateImageMimeType}
                                disabled={!!this.state.imageUpdateActionID}
                            />
                            {stickerSrc ? 
                            <button className="delete-image-button" title="delete pose" onClick={this.deleteSticker.bind(this,entry)}>
                                <AccessibleIcon className="fa fa-trash" label="delete pose"/>
                            </button>
                            : null }
                            <input type="text" value={entry.displayName} readOnly={entry.specialPurpose} onChange={(e)=>{this.setStickerDisplayName(entry,e)}}/>
                        </div>
                        );
                    })}
                    { this.state.imageUpdateActionID ? <LoadingSpinner/> : null }
                    <button className="add-sticker-button" title="add pose" onClick={this.addSticker} disabled={!!this.state.imageUpdateActionID}>
                        <AccessibleIcon className="fa fa-user-plus" label="add pose"/>
                        <span>Add Pose</span>
                    </button>
                    </div>
                    <ErrorBox error={this.state.error} />
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        );
    } // render
}; // EditCoachStickersModal

EditCoachStickersModal.propTypes = propTypes;
EditCoachStickersModal.defaultProps = defaultProps;

export default EditCoachStickersModal;